<script setup>
import moment from "moment"
moment.locale('id');
</script>
<template> 
    <penilaianCalonPenanggungJawab :dataPJO="dataPJO" />

    <p
        class="mb-3 mt-4"
        style="
            font-family: 'Inter-Thin';
            font-size: 0.9rem;
            letter-spacing: 0.1rem;
            font-weight: bold;
        "
    >
        PENILAIAN ADMINISTRASI
    </p>
    <p class="text-danger fst-italic fs-8 fw-bold">
        * Silahkan gunakan indikator <b>(+) (-)</b> untuk mengisi skor penilaian
    </p>
    <!-- <formPenilaian :evaluationItems="evaluationItems" @updateEvaluationItems="evaluationItems = $event"  /> -->
    <formPenilaian :dataPenilaianAdmin="dataPenilaianAdmin" :dataPJO="dataPJO" />
    <!-- @updateDataPenilaianAdmin="updateDataPenilaianAdmin"  -->
    
    <div class="d-flex justify-content-end mt-3" v-if="userData.role.includes('ADMIN') && (moment(dataPJO.tanggalPresentasi).format('YYYY-MM-DD') == moment(new Date()).format('YYYY-MM-DD'))">
        <button
            type="button"
            class="btn btn_cari w-25"
            @click="callSubmitPenilaian()"
            :hidden="dataSio.status==5||dataSio.status==6||dataSio.status==7||dataSio.status==8||dataSio.status==3"
            :disabled="disabled"
        >
            Approve
        </button>
    </div>
</template>

<script>
// import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
// import Datepicker from "vuejs3-datepicker"
// import axios from "axios";
import GlobalDataMixin from "../../../GlobalDataMixin"
// import Swal from "sweetalert2" 

import penilaianCalonPenanggungJawab from '@/pages/sio/penilaian/penilaianCalonPenanggungJawab.vue';
import formPenilaian from '@/pages/sio/penilaian/formPenilaian.vue';
import Swal from "sweetalert2";
// import {
//     API_BASE_URL, 
//     CMS_SET_PENILAIAN,
// } from "@/constants";

export default {
    mixins: [GlobalDataMixin],
    name: "penilaianAdministratif",
    components: {
        // FontAwesomeIcon,
        formPenilaian,
        penilaianCalonPenanggungJawab,
        // Datepicker,
    },
    props:{
        dataPJO:{
            type:Object,
            // required:true,
        },
        dataPenilaianAdmin:{
            type:Array,
            // required:true,
        },
        idPenjadwalan:Number||null,
        idPenilaianAdmin:Number||null,
        submitPenilaian:{
            type:Function
        },
        dataSio:{
          type:Object,
        },
        disabled: Boolean
    },
    data() {
        return { 
            // dataPenilaianAdmin:{},
            evaluationItems: [
                {
                    criteria: "Surat Permohonan Pengesahan PJO sudah di submit dan memadai",
                    score: 0,
                    maxScore: 2,
                    note: "Surat permohonan belum memadai",
                    isEditingNote: false,
                    editNote: '', // Temporary storage for the note being edited
                },
                {
                    criteria: "Surat Pernyataan Dukungan Pimpinan Tertinggi sudah di submit dan memadai",
                    score: 0,
                    maxScore: 2,
                    note: "Surat permohonan belum memadai",
                    isEditingNote: false,
                    editNote: '', // Temporary storage for the note being edited
                },
                {
                    criteria: "Surat Pernyataan Calon PJO sudah di submit dan memadai",
                    score: 0,
                    maxScore: 2,
                    note: "Surat permohonan belum memadai",
                    isEditingNote: false,
                    editNote: '', // Temporary storage for the note being edited
                },
                {
                    criteria: "Daftar Riwayat Hidup Calon PJO sudah di submit dan memadai",
                    score: 0,
                    maxScore: 2,
                    note: "Surat permohonan belum memadai",
                    isEditingNote: false,
                    editNote: '', // Temporary storage for the note being edited
                },
                {
                    criteria: "Surat Pernyataan Kebenaran Dokumen sudah di submit dan memadai",
                    score: 0,
                    maxScore: 2,
                    note: "Surat permohonan belum memadai",
                    isEditingNote: false,
                    editNote: '', // Temporary storage for the note being edited
                },
                {
                    criteria: "Calon PJO memiliki sertifikat kompetensi Pengawas Operasional yang memadai",
                    score: 0,
                    maxScore: 2,
                    note: "Surat permohonan belum memadai",
                    isEditingNote: false,
                    editNote: '', // Temporary storage for the note being edited
                },
                {
                    criteria: "Calon PJO memiliki ijazah / sertifikat kompetensi teknis lainnya yang memadai sesuai pekerjaan",
                    score: 0,
                    maxScore: 2,
                    note: "Surat permohonan belum memadai",
                    isEditingNote: false,
                    editNote: '', // Temporary storage for the note being edited
                },
            ],
        }
    },
    mounted() {

    },
    computed: { 
    },
    methods: { 
        // updateDataPenilaianAdmin(updatedData) {
        //     this.dataPenilaianAdmin = updatedData;
        // },
        callSubmitPenilaian(){
          Swal.fire({
            title: "Konfirmasi",
            text: "Apakah Anda yakin akan simpan data ini ?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#1db61d",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Simpan",
            cancelButtonText: "Batal",
          }).then((result) => {
            if (result.isConfirmed) {
              this.submitPenilaian(this.idPenilaianAdmin,'administrasi')
            }
          })
        },
    }
}
</script>

<style>

</style>
